import React from 'react';
import PropTypes from 'prop-types';

import { t } from '../../../../../../modules/infra/i18n';
import Modal from '../../../../../common/Modal';

const ChangeFulfillmentConfirmation = ({ onSubmit, openedIsOn, openedOff }) =>
  // TODO[ECOM-241] - Uncomment this
  // const productLabel = pluralize('product', connectedProductsCount);

   (
     <Modal
       className="shopify-modal shopify-disconnect-modal"
       display-if={openedIsOn}
       title={t('settings:integrations.shopify.confirm_changes_title')}
       close={openedOff}
       showCloseButton
     >
       <div className="modal-container">
         <div className="modal-container__body u-co-gray">
          {t('settings:integrations.shopify.change_fulfillment_confirmation')}
          {/* TODO[ECOM-241] - Use connectedProductsCount from the API side */}
           {/* <p>{connectedProductsCount} connected {productLabel} will be desynchronized as a result.</p> */}
         </div>
       </div>
       <div className="modal-controls">
         <button
           type="button"
           className="c-btn c-btn--medium c-btn--grey"
           onClick={openedOff}
         >
          {t('common:buttons.cancel')}
        </button>
         <button
           type="button"
           className="c-btn c-btn--medium c-btn--red"
           onClick={onSubmit}
         >
          {t('settings:integrations.shopify.change_button')}
        </button>
       </div>
     </Modal>
  );

ChangeFulfillmentConfirmation.propTypes = {
  connectedProductsCount: PropTypes.number.isRequired,
  openedIsOn: PropTypes.bool.isRequired,
  openedOff: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default ChangeFulfillmentConfirmation;
